import {patientDirectory} from "../access/patientDirectory";
import {
    onSnapshot
} from "../access/firestore";

import {
    db
} from "../firebase";

import {
    useEffect,
    useState
} from "react";

import {
    useClinic
} from "../context/ClinicContext";

import {
    Search,
    Users,
    Phone,
    Plus,
    ChevronRight
} from "lucide-react";

import MobilePacienteDetalle
    from "./MobilePacienteDetalle";

import PacienteForm
    from "../PacienteForm";

export default function
MobilePatients({

    onSelectPatient

}) {

    const {
        clinicId
    } = useClinic();


    const [
        pacientes,
        setPacientes
    ] = useState([]);


    const [
        busqueda,
        setBusqueda
    ] = useState("");


    const [
        pacienteSeleccionado,
        setPacienteSeleccionado
    ] = useState(null);

    const [
        mostrarNuevoPaciente,
        setMostrarNuevoPaciente
    ] = useState(false);

    useEffect(() => {

        if (!clinicId)
            return;


        return onSnapshot(

            patientDirectory(db,clinicId),

            snap => {

                setPacientes(

                    snap.docs.map(
                        doc => ({

                            id:
                                doc.id,

                            ...doc.data()

                        })
                    )

                );

            }

        );

    }, [clinicId]);


    const pacientesFiltrados =
        pacientes.filter(
            paciente => {

                const texto =
                    busqueda
                        .toLowerCase()
                        .trim();


                const nombre =
                    String(
                        paciente.nombre
                        || ""
                    )
                        .toLowerCase();


                const apellidos =
                    String(
                        paciente.apellidos
                        || ""
                    )
                        .toLowerCase();


                const telefono =
                    String(
                        paciente.telefono
                        || ""
                    )
                        .toLowerCase();


                const whatsapp =
                    String(
                        paciente.whatsapp
                        || ""
                    )
                        .toLowerCase();


                return (

                    nombre.includes(texto)

                    ||

                    apellidos.includes(texto)

                    ||

                    `${nombre} ${apellidos}`
                        .includes(texto)

                    ||

                    telefono.includes(texto)

                    ||

                    whatsapp.includes(texto)

                );

            }
        );


    if (pacienteSeleccionado) {

        return (

            <MobilePacienteDetalle

                paciente={
                    pacienteSeleccionado
                }

                onBack={() =>

                    setPacienteSeleccionado(
                        null
                    )

                }

            />

        );

    }


    const obtenerNombre = (
        paciente
    ) => {

        return (

            [
                paciente.nombre,
                paciente.apellidos
            ]
                .filter(Boolean)
                .join(" ")

            ||

            "Sin nombre"

        );

    };


    const obtenerIniciales = (
        paciente
    ) => {

        const nombre =
            obtenerNombre(
                paciente
            );

        const partes =
            nombre
                .trim()
                .split(/\s+/);


        if (
            partes.length === 1
        ) {

            return partes[0]
                .slice(0, 2)
                .toUpperCase();

        }


        return (

            partes[0][0] +

            partes[
                partes.length - 1
            ][0]

        ).toUpperCase();

    };


    return (

        <div
            style={{
                minHeight:
                    "100vh",

                padding:
                    "18px 16px 110px",

                background:
                    "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)",

                boxSizing:
                    "border-box"
            }}
        >

            {/* ENCABEZADO */}

            <div
                style={{
                    display:"flex",
                    alignItems:"center",
                    justifyContent:
                        "space-between",

                    marginBottom:18,

                    padding:
                        "4px 2px"
                }}
            >

                <div
                    style={{
                        display:"flex",
                        alignItems:"center",
                        gap:12
                    }}
                >

                    <div
                        style={{
                            width:46,
                            height:46,
                            borderRadius:16,

                            background:
                                "linear-gradient(135deg, #2563eb, #3b82f6)",

                            display:"flex",
                            alignItems:"center",
                            justifyContent:
                                "center",

                            boxShadow:
                                "0 6px 16px rgba(37,99,235,0.20)"
                        }}
                    >

                        <Users
                            size={24}
                            strokeWidth={2}
                            color="#ffffff"
                        />

                    </div>


                    <div>

                        <div
                            style={{
                                fontSize:23,
                                fontWeight:750,
                                color:"#0f172a",
                                lineHeight:1.15,
                                letterSpacing:
                                    "-0.4px"
                            }}
                        >

                            Pacientes

                        </div>


                        <div
                            style={{
                                fontSize:13,
                                color:"#64748b",
                                marginTop:4
                            }}
                        >

                            Expedientes del consultorio

                        </div>

                    </div>

                </div>


                <div
                    style={{
                        display:"flex",
                        alignItems:"center",
                        gap:8
                    }}
                >

                    <div
                        style={{
                            display:"flex",
                            alignItems:"center",
                            gap:6,

                            padding:
                                "6px 10px",

                            borderRadius:12,

                            background:"#ffffff",

                            border:
                                "1px solid #e2e8f0",

                            color:"#64748b",

                            fontSize:12,

                            fontWeight:600
                        }}
                    >

                        <Users
                            size={14}
                            strokeWidth={2}
                        />

                        {
                            pacientes.length
                        }

                    </div>


                    <button
                        type="button"
                        onClick={() =>
                            setMostrarNuevoPaciente(true)
                        }
                        style={{
                            width:42,
                            height:42,
                            border:"none",
                            borderRadius:14,
                            background:"#2563eb",
                            color:"#ffffff",
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            boxShadow:
                                "0 6px 16px rgba(37,99,235,0.22)"
                        }}
                    >

                        <Plus
                            size={22}
                            strokeWidth={2.4}
                        />

                    </button>

                </div>

            </div>


            {/* BUSCADOR */}

            <div
                style={{
                    position:"relative",
                    marginBottom:18
                }}
            >

                <Search
                    size={20}
                    strokeWidth={2}
                    color="#94a3b8"

                    style={{
                        position:"absolute",
                        left:15,
                        top:"50%",
                        transform:
                            "translateY(-50%)",
                        pointerEvents:"none"
                    }}

                />


                <input

                    placeholder=
                        "Buscar paciente..."

                    value={
                        busqueda
                    }

                    onChange={
                        e =>
                            setBusqueda(
                                e.target.value
                            )
                    }

                    style={{

                        width:"100%",

                        height:52,

                        padding:
                            "0 16px 0 46px",

                        borderRadius:18,

                        border:
                            "1px solid #e2e8f0",

                        background:"#ffffff",

                        color:"#0f172a",

                        fontSize:15,

                        outline:"none",

                        boxSizing:
                            "border-box",

                        boxShadow:
                            "0 3px 12px rgba(15,23,42,0.05)"

                    }}

                />

            </div>


            {/* SIN RESULTADOS */}

            {

                pacientesFiltrados.length ===
                0 && (

                    <div
                        style={{
                            background:"#ffffff",

                            border:
                                "1px solid #e2e8f0",

                            borderRadius:22,

                            padding:
                                "42px 24px",

                            textAlign:"center",

                            boxShadow:
                                "0 4px 16px rgba(15,23,42,0.04)"
                        }}
                    >

                        <div
                            style={{
                                width:56,
                                height:56,
                                margin:
                                    "0 auto 14px",

                                borderRadius:18,

                                background:
                                    "#eff6ff",

                                display:"flex",
                                alignItems:"center",
                                justifyContent:
                                    "center"
                            }}
                        >

                            <Users
                                size={28}
                                strokeWidth={1.8}
                                color="#2563eb"
                            />

                        </div>


                        <div
                            style={{
                                fontSize:15,
                                fontWeight:700,
                                color:"#0f172a"
                            }}
                        >

                            No se encontraron pacientes

                        </div>


                        <div
                            style={{
                                fontSize:13,
                                color:"#64748b",
                                marginTop:5
                            }}
                        >

                            Intenta buscar por nombre
                            o teléfono.

                        </div>

                    </div>

                )

            }


            {/* LISTA */}

            {

                pacientesFiltrados.map(
                    paciente => {

                        const nombre =
                            obtenerNombre(
                                paciente
                            );

                        const iniciales =
                            obtenerIniciales(
                                paciente
                            );

                        const telefono =
                            paciente.whatsapp
                            ||
                            paciente.telefono
                            ||
                            null;


                        return (

                            <div

                                key={
                                    paciente.id
                                }

                                className="vd-mobile-patient-card"
                                role="button"
                                tabIndex={0}
                                aria-label={`Abrir expediente de ${nombre}`}

                                onClick={() => {

                                    setPacienteSeleccionado(
                                        paciente
                                    );


                                    if (
                                        onSelectPatient
                                    ) {

                                        onSelectPatient(
                                            paciente
                                        );

                                    }

                                }}

                                onKeyDown={event => {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        setPacienteSeleccionado(paciente);
                                        onSelectPatient?.(paciente);
                                    }
                                }}

                                style={{

                                    background:
                                        "#ffffff",

                                    padding:
                                        "14px 14px",

                                    borderRadius:20,

                                    marginBottom:10,

                                    cursor:
                                        "pointer",

                                    border:
                                        "1px solid #e8edf3",

                                    boxShadow:
                                        "0 2px 8px rgba(15,23,42,0.04)",

                                    display:"flex",

                                    alignItems:
                                        "center",

                                    gap:12

                                }}

                            >

                                {/* AVATAR */}

                                <div
                                    style={{
                                        width:46,
                                        height:46,
                                        borderRadius:16,

                                        background:
                                            "linear-gradient(135deg, #dbeafe, #eff6ff)",

                                        color:
                                            "#2563eb",

                                        display:"flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",

                                        fontSize:13,
                                        fontWeight:750,

                                        flexShrink:0
                                    }}
                                >

                                    {

                                        iniciales

                                    }

                                </div>


                                {/* DATOS */}

                                <div
                                    style={{
                                        minWidth:0,
                                        flex:1
                                    }}
                                >

                                    <div
                                        style={{
                                            fontSize:15,
                                            fontWeight:700,
                                            color:"#0f172a",

                                            whiteSpace:
                                                "nowrap",

                                            overflow:
                                                "hidden",

                                            textOverflow:
                                                "ellipsis"
                                        }}
                                    >

                                        {
                                            nombre
                                        }

                                    </div>


                                    <div
                                        style={{
                                            display:"flex",
                                            alignItems:
                                                "center",

                                            gap:6,

                                            marginTop:5,

                                            fontSize:13,

                                            color:"#64748b",

                                            whiteSpace:
                                                "nowrap",

                                            overflow:
                                                "hidden",

                                            textOverflow:
                                                "ellipsis"
                                        }}
                                    >

                                        {

                                            telefono
                                                ?

                                                <>

                                                    <Phone
                                                        size={14}
                                                        strokeWidth={1.9}
                                                    />

                                                    <span>

                                                        {
                                                            telefono
                                                        }

                                                    </span>

                                                </>

                                                :

                                                <>

                                                    <Phone
                                                        size={14}
                                                        strokeWidth={1.9}
                                                    />

                                                    <span>

                                                        Sin teléfono

                                                    </span>

                                                </>

                                        }

                                    </div>

                                </div>

                                <ChevronRight
                                    size={19}
                                    color="#94a3b8"
                                    strokeWidth={2}
                                    style={{ flexShrink: 0 }}
                                />

                            </div>

                        );

                    }

                )

            }

            {
                mostrarNuevoPaciente && (

                    <PacienteForm

                        onClose={() =>
                            setMostrarNuevoPaciente(false)
                        }

                        onSaved={nuevoPaciente => {

                            setMostrarNuevoPaciente(false);

                            setPacienteSeleccionado(
                                nuevoPaciente
                            );

                            if (onSelectPatient) {

                                onSelectPatient(
                                    nuevoPaciente
                                );

                            }

                        }}

                    />

                )
            }

        </div>

    );

}
